import { get, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getCommissions = (documentId, siteId) => {
  return get(`${url}/leasingoffers/${documentId}/${siteId}/commissions`);
};

const updateCommissions = (documentId, siteId, commissions, isSubsidy) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/commissions`, {
    documentId,
    siteId,
    commissions,
    isSubsidy
  });
};

const computeCommission = (
  documentId,
  siteId,
  commissionPercent,
  commissionAmount,
  calculationMethodId,
  percentChanged
) => {
  return put(`${url}/leasingoffers/${documentId}/${siteId}/computeCommission`, {
    documentId,
    siteId,
    commissionPercent,
    commissionAmount,
    calculationMethodId,
    percentChanged
  });
};

const getCalculationMethods = commissionId => {
  return get(`${url}/leasingdocument/${commissionId}/calculationMethods`, { commissionId: commissionId });
};

const exp = {
  getCommissions,
  updateCommissions,
  computeCommission,
  getCalculationMethods
};
export default exp;
